/* Call sites for the bundled libraries.
 *
 * This file is NOT loaded directly — the gulpfile concatenates
 * assets/js/lib/*.js and assets/js/*.js into built/source.js, and default.hbs
 * loads that bundle. Nothing here runs on its own; it is the layer that invokes
 * the libraries sitting alongside it, which only define functions.
 *
 * It was deleted in 2d9f54e as dead code, on the reasoning that no <script> tag
 * references it. Nothing does reference it by name — but it was being bundled
 * and had been running all along, so the deletion silently removed the only
 * invocation of the lightbox, responsive video, nav dropdown, pagination and
 * table wrapper. Nothing broke at the time only because the committed
 * built/source.js was stale and still carried the compiled copy; the next
 * rebuild would have dropped all five.
 *
 * Two blocks from the original are deliberately NOT restored, because those
 * really were duplicates and the inline copies in default.hbs are the live
 * ones: the tel:/mailto: linkifier and the FAQPage JSON-LD generator.
 *
 * The mobile burger toggle is also gone from here — it now lives inline in
 * default.hbs with the rest of the nav behaviour, which reads the .is-open
 * class it sets. Do not add it back here as well: two handlers would toggle
 * the class twice per click and the menu would never open.
 */

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');

    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
